import React, { useState } from "react";
import { AuthServices } from "../services/AuthServices";
import logo from "../../../assets/IMGS/shophrLogo.PNG";

const ForgotPasswordForm = ({ handleBackToLogin }) => {
  const [formData, setFormData] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleResetPasswordSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage(
      "If there is an email that matches this on our database we will send it a secure reset password link.",
    );
    try {
      await AuthServices.passwordReset(formData);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setErrorMessage(error.message);
    }
  };

  return (
    <form onSubmit={handleResetPasswordSubmit}>
      <img src={logo} alt="logo" />

      <div className="login-credentials">
        <label htmlFor="businessEmail">Business Email</label>
        <input
          onChange={handleChange}
          required
          type="email"
          name="businessEmail"
          id="businessEmail"
          placeholder="Enter your email address"
        />
      </div>
      {errorMessage && (
        <div className="error-message">
          <p>{errorMessage}</p>
        </div>
      )}
      {loading ? (
        <button>Loading...</button>
      ) : (
        <button type="submit">Send Reset Email</button>
      )}
      <p className="already-a-partner" onClick={handleBackToLogin}>
        Back to Login
      </p>
    </form>
  );
};

export default ForgotPasswordForm;
